export default class {
	//given an array of valuattime, get all timestamps and make sure they are date objects.
	static normaliseTimestamps(values) {
		for (var ii = 0; ii < values.length; ii++) {
			if (typeof values[ii].timestamp === "string") {
				values[ii].timestamp = new Date(values[ii].timestamp);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/Live/LiveFeed/misc.js